export default __webpack_public_path__ + "static/media/i360-logo.3d471b10.png";